import Vue from 'vue';
import Vuex from 'vuex';
import moment from 'moment';
import { database, functions } from '@/firebase';

Vue.use(Vuex);

// eslint-disable-next-line import/prefer-default-export
export const store = new Vuex.Store({
  state: {
    authStatusKnown: false,
    profile: null,
    VMSWidgetsStatus: null,
    VMS: null,
    toolbarTitle: null,
    visitorLogs: [],
    activeVisitors: 0,
    totalVisitors: 0,
    activeUsers: 0,
    totalUsers: 0,
    expctedVisitors: 0,
    snackbar: {
      toggle: false,
      message: '',
      timeout: 6000,
      color: 'success',
      top: false,
      right: false,
      bottomCenter: false,
      multiLine: true,
    },
  },
  getters: {},
  mutations: {
    TOGGLE_SNACKBAR(state, p) {
      (state.snackbar.toggle = p.toggle),
        (state.snackbar.message = p.message),
        (state.snackbar.timeout = p.timeout),
        (state.snackbar.color = p.color),
        (state.snackbar.top = p.top),
        (state.snackbar.right = p.right),
        (state.snackbar.bottomCenter = p.bottomCenter);
    },

    setSnackbar(state, payload) {
      state.snackbar = payload;
    },
    
    setAuthStatus(state, payload) {
      state.authStatusKnown = payload.authStatusKnown;
    },

    setProfile(state, payload) {
      state.profile = payload.profile;
    },

    setWidgetStatus(state, payload) {
      state.VMSWidgetsStatus = payload.VMSWidgetsStatus;
    },

    setVMS(state, payload) {
      state.VMS = payload.VMS;
    },

    setToolbarTitle(state, payload) {
      state.toolbarTitle = payload.toolbarTitle;
    },

    setActiveVisitors(state, payload) {
      state.activeVisitors = payload;
    },

    setTotalVisitors(state, payload) {
      state.totalVisitors = payload;
    },

    setActiveUsers(state, payload) {
      state.activeUsers = payload;
    },

    setTotalUsers(state, payload) {
      state.totalUsers = payload;
    },

    setVisitorLog(state, payload) {
      state.visitorLogs = payload;
    },

    setExpectedVisitors(state, payload) {
      state.expctedVisitors = payload;
    }
  },
  actions: {
    getActiveUsers({ commit }) {
      functions
        .httpsCallable('admin-stats-activeUsers')
        .call()
        .then(result => {
          commit('setActiveUsers', result.data);
        });
    },
    getTotalUsers({ commit }) {
      functions
        .httpsCallable('admin-stats-totalUsers')
        .call()
        .then(result => {
          commit('setTotalUsers', result.data);
        });
    },
    getVisitorLog({ commit, state }) {
      const startAt = moment()
        .startOf('day')
        .toISOString();
      const endAt = moment()
        .endOf('day')
        .toISOString();
      const path =
        state.profile.role === 'admin'
          ? `vms/${state.VMS.lid}/tenants_data/${state.profile.cid}/visitor_log`
          : `vms/${state.VMS.lid}/visitor_log`;
      database
        .ref(path)
        .orderByChild('checkInDate')
        .startAt(startAt)
        .endAt(endAt)
        .once('value')
        .then(logSnapshot => {
          const log = logSnapshot.val();
          if (log) {
            let logArray = [];
            Object.keys(log).forEach(element => {
              logArray.push(log[element]);
            });
            commit('setVisitorLog', logArray);
          }
        });
    },
    getExpectedVisitors({ commit, state }) {
      const startAt = moment()
        .startOf('day')
        .toISOString();
      const endAt = moment()
        .endOf('day')
        .toISOString();
      database
        .ref(`vms/${state.VMS.lid}/tenants_data/${state.profile.cid}/invites`)
        .orderByChild('expectedAt')
        .startAt(startAt)
        .endAt(endAt)
        .once('value')
        .then(invitesSnapshot => {
          const invites = invitesSnapshot.val();
          if (invites) {
            let invitesArray = [];
            Object.keys(invites).forEach(element => {
              invitesArray.push(invites[element]);
            });
            const expected = invitesArray.filter(invite => {
              invite.used === false;
            });
            commit('setExpectedVisitors', expected.length);
          }
        });
    }
  }
});
